import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./SectionContainer.module.scss";
export type SectionContainerProps = {
  heading?: string;
  inverted?: boolean;
  nodivider?: boolean;
  padded?: boolean;
  ypadded?: boolean;
  hidden?: boolean;
  children: React.ReactNode;
};
export const SectionContainer: React.FC<SectionContainerProps> = t0 => {
  const $ = _c(17);
  const {
    heading,
    inverted,
    nodivider,
    padded,
    ypadded: t1,
    children
  } = t0;
  const ypadded = t1 === undefined ? true : t1;
  const t2 = inverted ? styles.inverted : "";
  let t3;
  if ($[0] !== t2) {
    t3 = [styles.section__container, t2];
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const containerClasses = t3;
  const t4 = nodivider ? "" : styles.divider;
  let t5;
  if ($[2] !== t4) {
    t5 = [styles.section__heading, t4];
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const headingClasses = t5;
  const t6 = padded ? styles.padded : "";
  const t7 = ypadded ? styles.ypadded : "";
  let t8;
  if ($[4] !== t6 || $[5] !== t7) {
    t8 = [styles.section__content, t6, t7];
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const contentClasses = t8;
  const t9 = containerClasses.join(" ");
  const t10 = headingClasses.join(" ");
  let t11;
  if ($[7] !== heading || $[8] !== t10) {
    t11 = <span className={t10}>{heading}</span>;
    $[7] = heading;
    $[8] = t10;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const t12 = contentClasses.join(" ");
  let t13;
  if ($[10] !== children || $[11] !== t12) {
    t13 = <div className={t12}>{children}</div>;
    $[10] = children;
    $[11] = t12;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] !== t11 || $[14] !== t13 || $[15] !== t9) {
    t14 = <section className={t9}>{t11}{t13}</section>;
    $[13] = t11;
    $[14] = t13;
    $[15] = t9;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  return t14;
};